import { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import type { CardStatusType, ContractorStepDetailsCardStatus } from '../types'
import { getCardStatus } from '../utils'

const CARD_STATUS_LABEL: Record<CardStatusType, string> = {
  Valid: 'Valid',
  Delayed: 'Delayed',
  NotValid: 'Not Valid',
}

const CARD_STATUS_STYLES: Record<CardStatusType, { bg: string }> = {
  Valid: { bg: colors.COLORS_GREEN_200 },
  Delayed: { bg: colors.COLORS_BLUE_200 },
  NotValid: { bg: colors.SHADES_GREY_200 },
}

const CARD_STATUS_TEXT_COLOR: Record<CardStatusType, string> = {
  Valid: colors.COLORS_GREEN_500,
  Delayed: colors.COLORS_BLUE_500,
  NotValid: colors.SHADES_GREY_600,
}

export interface ContractorStepDetailsCardStatusBadgeProps {
  status: ContractorStepDetailsCardStatus
}

const ContractorStepDetailsCardStatusBadgeComponent = ({
  status,
}: ContractorStepDetailsCardStatusBadgeProps) => {
  const cardStatus = getCardStatus(status)
  const styles = CARD_STATUS_STYLES[cardStatus]
  const label = CARD_STATUS_LABEL[cardStatus]
  const textColor = CARD_STATUS_TEXT_COLOR[cardStatus]

  return (
    <div css={[tw`px-2 py-0.5 rounded-[10px]`, { backgroundColor: styles.bg }]}>
      <Typography variant="subtitle2" sx={{ color: textColor }}>
        {label}
      </Typography>
    </div>
  )
}

export const ContractorStepDetailsCardStatusBadge = memo(
  ContractorStepDetailsCardStatusBadgeComponent,
)
